import { useStaticQuery, graphql } from 'gatsby';

import { extractUpdates } from './helpers';

const useUpdates = () => {
  const queryResponse = useStaticQuery(graphql`
    query {
      allWordpressPost {
        edges {
          node {
            id
            title
            slug
            status
            content
            format
            categories
            jetpack_featured_media_url
            date(formatString: "DD MMMM YYYY")
          }
        }
      }
    }
  `);
  return extractUpdates(queryResponse);
};

export { useUpdates };
